__turbopack_context__.v({
  "mainContent": "_5Qb2Iq_mainContent",
  "root": "_5Qb2Iq_root",
  "tab": "_5Qb2Iq_tab",
  "tabs": "_5Qb2Iq_tabs",
  "testCards": "_5Qb2Iq_testCards",
});
